import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component, inject, provide } from 'intact-vue-next';
import template from './template.vdt';
import { makeLayoutStyles } from './styles';
import { addStyle } from '../utils';
import { ROOT_LAYOUT, LAYOUT, getStyle, BODY } from './helpers';
import { useParse } from './useParse';
import { useConfigContext } from '../config';
export var Layout = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Layout, _Component);
  function Layout() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.parse = useParse();
    _this.layout = inject(LAYOUT, null);
    _this.body = inject(BODY, null);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Layout.prototype;
  _proto.init = function init() {
    provide(LAYOUT, this);
    if (!this.layout) {
      provide(ROOT_LAYOUT, this);
    }
  };
  _proto.getClassNames = function getClassNames() {
    var _ref;
    var _this$get = this.get(),
      className = _this$get.className,
      children = _this$get.children;
    var _this$parse = this.parse(),
      hasAside = _this$parse.hasAside;
    var k = this.config.k;
    return _ref = {}, _ref[k + "-layout"] = true, _ref[k + "-has-aside"] = hasAside, _ref[makeLayoutStyles(k)] = true, _ref[className] = className, _ref;
  };
  _proto.getStyles = function getStyles() {
    var style = this.get('style');
    var layout = this.layout;
    if (!layout || this.body) return style;
    var _layout$parse = layout.parse(),
      hasFixedHeader = _layout$parse.hasFixedHeader,
      headerHeight = _layout$parse.headerHeight,
      hasFixedAside = _layout$parse.hasFixedAside,
      asideWidth = _layout$parse.asideWidth;
    if (!hasFixedHeader && !hasFixedAside) return style;
    // add margin-top if the parent layout has fixed header
    return addStyle(style, {
      marginTop: hasFixedHeader ? getStyle(headerHeight) : null,
      paddingLeft: hasFixedAside ? getStyle(asideWidth) : null
    });
  };
  return Layout;
}(Component);
Layout.template = template;